import * as React from 'react';

function SvgEndTimeCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g data-name="Layer 2">
        <path
          fill="#5f59ff"
          fillRule="evenodd"
          d="M7.66 0a1 1 0 011.22 1 1 1 0 01-.75 1 7.78 7.78 0 00-2.57 1.1 1 1 0 01-1.22-.16 1 1 0 01.16-1.59A10.19 10.19 0 017.66 0zM1.35 4.55a1 1 0 011.71 1.09A8.09 8.09 0 002 8.23 1 1 0 011 9a1 1 0 01-1-1.25 10.5 10.5 0 011.35-3.2zM0 12.26A1 1 0 011 11a1 1 0 011 .76 7.7 7.7 0 001.06 2.59 1 1 0 01-1.72 1.08A10.61 10.61 0 010 12.26zM7.66 20a10.3 10.3 0 01-3.16-1.35 1 1 0 01-.15-1.57 1 1 0 011.22-.16A8 8 0 008.13 18a1 1 0 01.75 1 1 1 0 01-1.22 1zm4.53 0a10.26 10.26 0 000-20 1 1 0 00-1.24 1 1 1 0 00.76 1 8.19 8.19 0 010 15.93 1 1 0 00.48 2zm.48-14H7.33A1.34 1.34 0 006 7.33v5.34A1.34 1.34 0 007.33 14h5.34A1.34 1.34 0 0014 12.67V7.33A1.34 1.34 0 0012.67 6z"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
}

export default SvgEndTimeCircle;
